import React, { useState, useEffect, useRef } from "react";
import Styles from "./DataTable.module.css";
import classnames from "classnames";

function DataTable(props) {
  const [shouldEnableScrolling, setShouldEnableScrolling] = useState(false);
  let lastChildOfTable = useRef();
  useEffect(() => {
    let parentScrollElement = document.getElementById("dashboardLayout");
    const handleScroll = () => {
      const element = document.getElementById(`targetElement_${props.type}`);
      // const elementOffsetTop = element && element.offsetTop;

      // const windowScrollTop = parentScrollElement.scrollTop;
      let panelBodyElement = document.getElementById(props.parentId);
      let parentElementPosition = parentScrollElement?.getBoundingClientRect();
      let panelBodyPosition = panelBodyElement?.getBoundingClientRect();
      let targetElementPosition = element?.getBoundingClientRect();

      if (element) {
        if (parentElementPosition?.top + 80 >= panelBodyPosition?.top) {
          let differenceInHeight =
            targetElementPosition?.top - panelBodyPosition?.top + 30;
          let heightOfTargetElement =
            parentElementPosition.height - differenceInHeight + "px";
          element.style.height = heightOfTargetElement;
          setShouldEnableScrolling(true);
        } else {
          setShouldEnableScrolling(false);
        }
      }
    };
    parentScrollElement.addEventListener("scroll", handleScroll);
    return () => {
      parentScrollElement.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const throttleRef = useRef(false);
  useEffect(() => {
    const element = document.getElementById(`targetElement_${props.type}`);
    if (!element) return;
    
    const checkIfBottomReached = () => {
      if (!throttleRef.current) {
        if (lastChildOfTable?.current) {
          const panelBodyElement = document.getElementById(props.parentId);
          if (!panelBodyElement) return;
          
          const panelBodyBottom = panelBodyElement.getBoundingClientRect().bottom;
          const lastChildBottom = lastChildOfTable.current.getBoundingClientRect().bottom;
          const containerHeight = panelBodyElement.clientHeight;
          
          // Check if we need more data either because we're near bottom
          // or because container is larger than content
          const needsMoreData = 
            (lastChildBottom <= panelBodyBottom + 100) || // near bottom
            (containerHeight > lastChildBottom - panelBodyElement.getBoundingClientRect().top); // container bigger than content
          
          if (needsMoreData && !props.loadingData) {
            console.log("fetching data due to space needed");
            props.fetch();
            
            throttleRef.current = true;
            setTimeout(() => {
              throttleRef.current = false;
            }, 500);
          }
        }
      }
    };

    const handleScroll = () => {
      checkIfBottomReached();
    };
    
    const handleResize = () => {
      // Small delay to ensure DOM measurements are accurate after resize
      setTimeout(checkIfBottomReached, 100);
    };
    
    element.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    
    // Initial check in case the container is larger than content
    checkIfBottomReached();
    
    return () => {
      element.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [props.type, props.parentId, props.fetch, props.loadingData]);

  function getHeadingData() {
    switch (props.type) {
      case "task":
        return [
          "assignor",
          "task id",
          "title",
          "other assignees",
          // "tag",
          "due date",
          "comments",
        ];
      case "bug":
        return [
          "ASSIGNOR",
          "bug id",
          "summary",
          "status",
          "other assignee",
          "due date",
          "comments",
        ];
      case "uptime":
        return ["status", "site", "uptime", "respose time"];
    }
  }

  function rowStyle() {
    switch (props.type) {
      case "task":
        return `1fr 0.5fr 4fr 2fr 2fr 2fr 2.2em`;
      case "bug":
        return `1fr 0.5fr 4fr 2fr 2fr 2fr 2.2em`;
      case "uptime":
        return `0.5fr 1fr 1fr 1fr 5fr`;
      default:
        return `1fr 0.5fr 4fr 2fr 2fr 2fr 2.2em`;
    }
  }
  let headingData = getHeadingData();

  let bodyData = props.rowData ?? [];
  let rowsStyles = {
    gridTemplateColumns: rowStyle(),
  };

  function loadingDataRowUi(numberOfRows) {
    let arr = Array.from({ length: numberOfRows }, (v, i) => i);

    return (
      <div className={Styles.loadingBox} style={rowsStyles}>
        {arr.map((val, index) => {
          return (
            <div
              className={classnames(Styles.bodyRow)}
              style={rowsStyles}
              key={index}
            >
              <div
                style={{
                  width: "2.5em",
                  height: "2.5em",
                  borderRadius: "20em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "3.75em",
                  height: "0.625em",
                  borderRadius: "0.5em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "18.0625em",
                  height: "0.625em",
                  borderRadius: "0.5em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  borderRadius: "10em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "4.375em",
                  height: "1.5em",
                  borderRadius: "0.5em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "3.75em",
                  height: "0.625em",
                  borderRadius: "0.5em",
                  background: "var(--lightGrey)",
                }}
              ></div>
              <div
                style={{
                  width: "3.75em",
                  height: "0.625em",
                  borderRadius: "0.5em",
                  background: "var(--lightGrey)",
                }}
              ></div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.rowWrapper}>
        {props.selectMultiple? <input
          type="radio"
          className={Styles.selectRadio}
          style={{
            marginBottom: 0,
            // visibility:
            //   props.isAllSelected() || props.selectMultiple
            //     ? "visible"
            //     : "hidden",
          }}
          onClick={props.selectAll}
          // checked={props.isAllSelected()}
        />:''}
       
        {/* {props.selectMultiple ? (
          <input
            type="radio"
            className={Styles.selectRadio}
            style={{ marginBottom: 0 }}
            onClick={props.selectAll}
            checked={props.isAllSelected()}
          />
        ) : (
          ""
        )} */}

        <div className={Styles.headerRow} style={rowsStyles}>
          {headingData &&
            headingData.map((value, index) => {
              return (
                <p className={Styles.headerText} key={index}>
                  {value}
                </p>
              );
            })}
        </div>
      </div>

      <div
        className={Styles.body}
        id={`targetElement_${props.type}`}
        style={{
          overflow: shouldEnableScrolling ? "scroll" : "hidden",
          positin: "relative",
        }}
      >
        {props.loadingData && props.currentPage == 1
          ? loadingDataRowUi(5)
          : bodyData &&
            bodyData.map((value, index) => {
              let rowId = value?.valOb?.id;
              let selectId = `${rowId}`;
              let priority = value?.valOb?.priority;
              return (
                <div className={Styles.rowWrapper}>
                  {props.isRowSelected(selectId) || props.selectMultiple? <input
                    type="radio"
                    className={Styles.selectRadio}
                    checked={props.isRowSelected(selectId)}
                    // style={{
                    //   visibility:
                    //     props.isRowSelected(selectId) || props.selectMultiple
                    //       ? "visible"
                    //       : "hidden",
                    // }}
                    onClick={() => {
                      if (!props.selectMultiple) {
                        props.changeSelectMultiple(true);
                      }
                      props.selectRow(selectId);
                    }}
                  />:''}
                 
                  {/* {props.selectMultiple ? (
                    <input
                      type="radio"
                      className={Styles.selectRadio}
                      checked={props.isRowSelected(selectId)}
                    />
                  ) : (
                    ""
                  )} */}

                  <div
                    className={classnames(
                      Styles.bodyRow,
                      props.isRowSelected(selectId)
                        ? Styles.bodyRowSelected
                        : ""
                    )}
                    style={rowsStyles}
                    key={index}
                    onClick={(e) => {
                      if (props.selectMultiple) {
                        props.selectRow(selectId);
                      } else {
                        if (
                          e.target.getAttribute("class") &&
                          e.target
                            .getAttribute("class")
                            .search("DataTable_bodyRow") > -1
                        )
                        if(props.showInfoModalHandler){
                          props.showInfoModalHandler(value.valOb);
                        }
                      }
                    }}
                  >
                    {" "}
                    <div
                      className={Styles.priorityIndicator}
                      style={{
                        backgroundColor:
                          priority == 2
                            ? "var(--orange)"
                            : priority == 3
                            ? "var(--errorRed)"
                            : "",
                      }}
                    ></div>
                    {value.rowData.map((row, rowIndex) => {
                      let isOtherOption = false;
                      if (row?.props?.className?.search("otherOptions") > -1) {
                        isOtherOption = true;
                      }
                      return (
                        <div
                          key={rowIndex}
                          className={isOtherOption ? Styles.otherOptions : ""}
                        >
                          {row}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        {props.loadingData && props.currentPage != 1 ? loadingDataRowUi(1) : ""}
        <div ref={lastChildOfTable}></div>
      </div>
    </div>
  );
}

export default DataTable;
